import VatBlock from './VatBlock.vue'

export default VatBlock
